/**
 * Theme enum for light/dark mode support.
 */
export enum Theme {
  Light = 'light',
  Dark = 'dark',
  System = 'system',
}

export const THEME_VALUES = [Theme.Light, Theme.Dark, Theme.System] as const;

/**
 * Constant for hidden tool UI.
 * Used to mark tools that should not display any UI.
 */
export const HIDDEN_TOOL_UI = 'hidden';

/**
 * Widget plugins that run on the parent page (customer site).
 * Each plugin has a corresponding bridge script in extension-files/.
 */
export enum WidgetPlugin {
  /** Nagich (נגיש בקליק) - Israeli accessibility plugin sync */
  NagichAccessibility = 'nagich-accessibility',
  /** UserWay - accessibility widget sync */
  UserWayAccessibility = 'userway-accessibility',
  /** T5-specific plugin (Air Plan button, order tracking, cookie banner) */
  T5Plugin = 't5-plugin',
  /** T10-specific plugin (cookie banner handling) */
  T10Plugin = 't10-plugin',
  /** T4-specific plugin (CTA button for hotel search) */
  T4Plugin = 't4-plugin',
  /** T19-specific plugin (parent-frame contact-update for logged-in users) */
  T19Plugin = 't19-plugin',
  /** WallaShops-specific plugin (AI row in the site's search dropdown) */
  T13Plugin = 't13-plugin',
  /** Tenant-agnostic funnel bridge: mirrors allowlisted dataLayer events to Bazak */
  DataLayerBridge = 'datalayer-bridge',
  /** Tenant-agnostic: tells the chat when the embedding site signs someone in or out */
  HostSessionSignal = 'host-session-signal',
}
